<template>
  <div class="popup-main">
    <el-dialog
      width="420px"
      :title="selfData.id ? '编辑类目' : '新增类目'"
      :visible.sync="selfShow"
      :close-on-click-modal="false"
    >
      <el-form ref="refForm" :model="selfData" :rules="rules" label-width="100px">
        <el-form-item label="所属分类:">
          <el-input v-model="categoryName" size="mini" style="width: 250px" disabled />
        </el-form-item>
        <el-form-item label="上级类目:">
          <el-input v-model="selfData.parent_name" size="mini" style="width: 250px" disabled />
        </el-form-item>
        <el-form-item label="类目层级:">
          <el-input v-model="selfData.level" size="mini" style="width: 250px" disabled />
        </el-form-item>
        <el-form-item label="类目类型:">
          <el-select
            v-if="selfData.level < 2"
            v-model="selfData.lei_mu_lei_xing"
            size="mini"
            style="width: 250px"
          >
            <el-option
              v-for="(item, index) in categoryTypeList"
              class="flex flex-x-between"
              :key="index"
              :label="item.key"
              :value="item.val"
            />
          </el-select>
          <el-input
            v-else
            v-model="selfData.lei_mu_lei_xing"
            size="mini"
            style="width: 250px"
            disabled
          />
        </el-form-item>
        <el-form-item label="类目名称:" prop="name">
          <el-input v-model="selfData.name" size="mini" style="width: 250px" />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button size="mini" @click="popupCancel">取消</el-button>
        <el-button size="mini" type="primary" @click="popupConfirm">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      required: true
    },
    categoryName: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      selfShow: false,
      selfData: {},
      rules: {
        name: [{ required: true, message: '请输入类目' }]
      },
      categoryTypeList: [
        {
          key: '原料',
          val: '原料'
        },
        {
          key: '商品',
          val: '商品'
        },
        {
          key: '零件',
          val: '零件'
        },
        {
          key: '组装',
          val: '组装'
        },
        {
          key: '加工',
          val: '加工'
        },
        {
          key: '其他',
          val: '其他'
        }
      ]
    }
  },
  watch: {
    selfShow(val) {
      this.$emit('update:show', val)
    },
    data: {
      handler(val) {
        if (JSON.stringify(this.selfData) !== JSON.stringify(val)) {
          this.selfData = this.$util.deepCopy(val)
        }
      },
      deep: true,
      immediate: true
    }
  },
  mounted() {
    this.selfShow = this.show
  },
  methods: {
    // 弹窗取消
    popupCancel() {
      this.selfShow = false
      this.$emit('update:show', false)
    },
    // 弹窗确认
    popupConfirm() {
      this.$refs.refForm.validate((valid) => {
        if (valid) {
          this.$api({
            method: 'post',
            url: '/admin/gcvip/columnData/saveOrUpdate',
            data: this.selfData
          }).then((res) => {
            if (res.data.state === 'ok') {
              this.popupCancel()
              this.$emit('success')
              this.$message.success('保存成功')
            }
          })
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.popup-main {
}
</style>
